// Schalter (Handoff §4: Ganztägig, Unbefristet, Aktiv, Halber Tag) als iOS-Toggle mit Icon-Kachel.
import type { Icon } from '@phosphor-icons/react';
import { IosSchalter } from '../../ui/IosSchalter';
import { FeldHuelle } from './FormFeld';
import { GLANZ, SCHALTER_AN } from './form-stil';

export interface FormSchalterProps {
  /** Text neben dem Schalter (Beschriftung aus dem Code). */
  text: string;
  an: boolean;
  onChange: (an: boolean) => void;
  icon: Icon;
  /** Verlauf der Icon-Kachel */
  verlauf: string;
  tip?: string;
  gesperrt?: boolean;
}

export function FormSchalter({ text, an, onChange, icon: I, verlauf, tip, gesperrt }: FormSchalterProps) {
  return (
    <FeldHuelle tip={tip}>
      <div className="flex items-center" style={{ gap: 10, minHeight: 32 }}>
        <span aria-hidden className="relative flex shrink-0 items-center justify-center overflow-hidden" style={{
          width: 28, height: 28, borderRadius: 9, background: verlauf,
          boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.45),0 4px 10px -4px rgba(0,0,0,0.6)',
        }}>
          <span className="absolute inset-0" style={{ background: GLANZ }} />
          <I size={14} weight="fill" color="#fff" className="relative" />
        </span>
        <span className="min-w-0 flex-1" style={{ fontSize: 13.5, fontWeight: 700, color: 'rgba(255,255,255,0.85)' }}>{text}</span>
        <IosSchalter an={an} onChange={onChange} label={text} gesperrt={gesperrt} anFarbe={SCHALTER_AN} />
      </div>
    </FeldHuelle>
  );
}
